import type { CartProduct } from './cart'

/*
  Base
*/

export enum NotificationEventState {
  NotificationOpen = 'NotificationOpen',
  NotificationClose = 'NotificationClose'
}

export enum NotificationType {
  Error = 'Error',
  CartItemAdded = 'CartItemAdded',
  CartMerged = 'CartMerged',
  WishlistItemAdded = 'WishlistItemAdded',
  CartState = 'CartState'
}

export interface Notification<P = object> {
  type?: NotificationType
  props?: P
  state?: NotificationEventState
}

export interface NotificationsState {
  notification: Notification | null
  timer: number | null
  queue: Notification[]
  interval: number
}

/*
  CartItemAdded
*/

export interface CartMergedNotificationProps {
  productQty: number
}

export type CartMergedNotification = Notification<CartMergedNotificationProps>

/*
  CartItemAdded
*/

export interface CartItemAddedNotificationProps {
  product?: CartProduct
}

export type CartiItemAddedNotification = Notification<CartItemAddedNotificationProps>

/*
  Error
*/

export interface ErrorNotificationProps {
  title: string
  message: string
}

export interface ErrorNotification extends Notification<ErrorNotificationProps> {
  type: NotificationType.Error
}

/*
  CartState
*/

interface CartStateNotificationProduct {
  productQty: number
  productId: string
  productDescription: string
  itemPrice: string
  itemSubTotal: string
  subtotal: string
}

export interface CartStateNotificationProps {
  cartProducts: CartStateNotificationProduct[]
}

export type CartStateNotification = Notification<CartStateNotificationProps>
